export default class TravelServiceOrderItemFlight {
  start_place_id = null;
  end_place_id = null;
  seat_class = null;
  start_date = null;
  start_time = null;
  return_date = null;
  return_time = null;
  is_baggage = null;
  is_insurance = false;
  preferred_seat = null;
  additionalSegments = [];
}

export class TravelServiceOrderItemFlightAdditionalSegment {
  start_place_id = null;
  end_place_id = null;
  start_date = null;
  start_time = null;
}
